// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zXpl","footer":"styles_footer__1hXze","passCodeTooltip":"styles_passCodeTooltip__1uk8Z"};